import React, { useContext } from 'react';
import { PapiGallection, PapiUser } from '@wix/da-types-papi';
import { getCommentsBlockAnchor } from '../../helpers';
import CommentThread from '@wix/da-shared-react/pkg/CommentThread';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import { CommentableTypes } from '@wix/da-shared-react/pkg/Comment/types';
import { GallectionType } from '../../../../../../types/gallection';
import { SCRAPS_FOLDER_ID, ALL_FOLDER_ID } from '@wix/da-url';

import s from './FolderCommentThread.scss';

const NON_COMMENTABLE_FOLDERS = [ALL_FOLDER_ID, SCRAPS_FOLDER_ID];

export interface Props {
  folder: PapiGallection;
  featuredFolder: PapiGallection;
  currentUser: PapiUser;
}

export const FolderCommentThread: React.FC<Props> = ({
  folder,
  featuredFolder,
  currentUser,
}) => {
  const isMobile = useContext(MobileContext);
  if (!folder || !featuredFolder) {
    return null;
  }

  const typeId =
    folder.type === GallectionType.COLLECTION
      ? CommentableTypes.COMMENT_COLLECTION
      : CommentableTypes.COMMENT_GALLERY;
  // if we're showing a non-commentable folder, show 'Featured' comments instead
  const itemId = NON_COMMENTABLE_FOLDERS.includes(folder.folderId)
    ? featuredFolder.folderId
    : folder.folderId;

  return (
    <div
      id={getCommentsBlockAnchor(folder.folderId)}
      className={s['comments-wrapper']}
    >
      <div className={s['comments']}>
        <CommentThread
          className={s['comment-thread']}
          currentUser={currentUser}
          commentableTypeId={typeId}
          commentableItemId={itemId}
          statsAndControls={isMobile ? 'on' : 'order'}
          postbox={isMobile ? 'topmost' : 'top'}
        />
      </div>
    </div>
  );
};
FolderCommentThread.displayName = 'FolderCommentThread';

export default FolderCommentThread;
